// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateInitialLoad = (state, action) =>
    action.isInitialLoad;

export default (state = getDefaultState().initialLoad, action) => {

    const actionTypes = {
        [actions.UPDATE_TCSM_AUDIT_IS_INITIAL_LOAD]: updateInitialLoad
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/audits/reducers/initial-load.js